import React, { useState, useEffect, useMemo } from "react";
import "../../assets/Style.css";

export default function PartnerSlider() {
  const [partnerLogos, setPartnerLogos] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://codebuddys.in/wp-json/wp/v2/partners_logos?_embed&per_page=100")
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch partner logos");
        return res.json();
      })
      .then((data) => {
        if (Array.isArray(data)) {
          const list = data
            .map((item) => {
              const imgUrl =
                item._embedded?.["wp:featuredmedia"]?.[0]?.source_url ||
                item._embedded?.["wp:featuredmedia"]?.[0]?.media_details?.sizes?.full?.source_url;
              return {
                id: item.id,
                title: item.title?.rendered || "Partner",
                img: imgUrl,
                url: item.link || "#",
              };
            })
            .filter((item) => Boolean(item.img));

          setPartnerLogos(list);
        }
        setLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching partner logos:", err);
        setLoading(false);
      });
  }, []);

  // Ensure enough items so marquee loops seamlessly on all screen sizes
  const displayList = useMemo(() => {
    if (!partnerLogos || partnerLogos.length === 0) return [];
    let items = [...partnerLogos];
    while (items.length < 8) {
      items = [...items, ...partnerLogos];
    }
    return items;
  }, [partnerLogos]);

  // If loading or no logos found in WordPress, do not show dummy images
  if (loading || displayList.length === 0) {
    return null;
  }

  return (
    <section className="partner-section">
      <div className="partner-heading">
        <h2>Trusted by Leading Global Brands</h2>
        <p>
          We collaborate with forward-thinking enterprises to deliver powerful digital experiences
        </p>
      </div>

      <div className="partner-marquee-wrapper">
        <div className="partner-marquee-track">
          {/* Primary Group */}
          <div className="partner-marquee-group">
            {displayList.map((partner, index) => (
              <div className="partner-logo-box" key={`p1-${partner.id}-${index}`}>
                <div className="partner-card">
                  <img
                    src={partner.img}
                    alt={partner.title}
                    className="partner-logo-img"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>

          {/* Duplicated Group for Continuous Infinite Loop */}
          <div className="partner-marquee-group" aria-hidden="true">
            {displayList.map((partner, index) => (
              <div className="partner-logo-box" key={`p2-${partner.id}-${index}`}>
                <div className="partner-card">
                  <img
                    src={partner.img}
                    alt={partner.title}
                    className="partner-logo-img"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
